<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <!-- Auto generated sa_id -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaIdLabel }}</label>
                  <input v-model="vmWrkSubAgentFormData.sa_id" type="text" class="form-control"/>
                </div>

                <!-- Order -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaOrderIdLabel }}</label>
                  <input v-model="vmWrkSubAgentFormData.sa_order_id" type="number" min="1" class="form-control" placeholder="Enter order" required />
                </div>

                <!-- Agent (disabled in add to show selected agent name/id) -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentIdLabel }}</label>
                  <input
                    v-model="agentDisplayText"
                    type="text"
                    class="form-control"
                    disabled
                    readonly
                  />
                </div>

                <!-- Description -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaDescLabel }}</label>
                  <b-form-textarea v-model="vmWrkSubAgentFormData.sa_desc" rows="4" max-rows="8" placeholder="Enter sub agent description" required />
                </div>

                <!-- sa_type -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaTypeLabel }}</label>
                  <select v-model="vmWrkSubAgentFormData.sa_type" class="form-control" required @change="onSaTypeChange">
                    <option :value="null">Select type</option>
                    <option value="PROMPT">PROMPT</option>
                    <option value="API_CALL">API_CALL</option>
                    <option value="DB_QUERY">DB_QUERY</option>
                    <option value="FUNCTION">FUNCTION</option>
                    <option value="TOOL">TOOL</option>
                  </select>
                </div>

                <!-- sa_type=PROMPT -->
                <div class="col-md-12 mb-3" v-if="isPromptType">
                  <label>{{ cvSaActionLabel }}</label>

                  <div class="mb-2">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                      <multiselect
                        v-model="promptSelectedObj"
                        :options="promptOptions"
                        class="w-100"
                        :searchable="true"
                        :internal-search="false"
                        label="prompt_name"
                        track-by="prompt_name"
                        placeholder="Search and select prompt"
                        @search-change="onPromptSearchChange"
                        @input="onPromptSelected"
                        :allow-empty="false"
                        :loading="cvPromptLoadingStatus"
                      >
                        <span slot="noResult">No prompt found</span>
                      </multiselect>

                      <i
                        class="fa-solid fa-plus font-size-18 text-primary pointer"
                        title="Add Prompt"
                        @click="openPromptAddModal"
                      ></i>
                    </div>

                    <div class="mt-2 reference-textarea-box">
                      <div
                        class="reference-html"
                        v-html="(promptSelectedObj && promptSelectedObj.prompt) ? promptSelectedObj.prompt : ''"
                      />
                    </div>
                  </div>
                </div>

                <!-- sa_type=API_CALL or DB_QUERY -->
                <div class="col-md-12 mb-3" v-if="showActionDropdown">
                  <label>{{ cvSaActionLabel }}</label>
                  <div class="d-flex align-items-center" style="gap: 8px;">
                    <multiselect
                      v-model="actionFilterObj"
                      :options="serviceActions"
                      :searchable="true"
                      :internal-search="false"
                      label="service_activity"
                      track-by="service_activity"
                      placeholder="Search and select action"
                      @search-change="onActionSearchChange"
                      @input="onActionSelected"
                      :allow-empty="false"
                      :loading="cvActionLoadingStatus"
                      class="w-100"
                    >
                      <span slot="noResult">No Action found</span>
                    </multiselect>

                    <i
                      class="fa-solid fa-plus font-size-18 text-primary pointer"
                      title="Add Service Config"
                      @click="openWrkServiceConfigAddModal"
                    ></i>
                  </div>
                </div>

                <!-- sa_type=FUNCTION or TOOL -->
                <div class="col-md-12 mb-3" v-if="showFunctionToolInput">
                  <label>{{ cvSaActionLabel }}</label>
                  <b-form-textarea
                    v-model="vmWrkSubAgentFormData.sa_action"
                    :rows="6"
                    max-rows="12"
                    placeholder="Enter query/function/tool"
                    required
                  />
                </div>

                <!-- payload -->
                <div class="col-md-12 mb-3" v-if="showPayload">
                  <label>{{ cvSaPayloadLabel }}</label>
                  <div v-if="showActionDropdown" class="reference-textarea-box">
                    <div
                      class="reference-html"
                      v-html="(vmWrkSubAgentFormData && vmWrkSubAgentFormData.sa_payload) ? vmWrkSubAgentFormData.sa_payload : '-'"
                    />
                  </div>
                  <b-form-textarea
                    v-else
                    v-model="vmWrkSubAgentFormData.sa_payload"
                    :rows="4"
                    max-rows="8"
                    placeholder='Optional JSON payload e.g. {"user_id":null,"pdt_id":null}'
                  />
                </div>

                <!-- output -->
                <div class="col-md-12 mb-3" v-if="showOutput">
                  <label>{{ cvSaOutputLabel }}</label>
                  <b-form-textarea
                    v-model="vmWrkSubAgentFormData.sa_output"
                    :rows="4"
                    max-rows="10"
                    placeholder='Optional JSON output e.g. {"gps_id":null}'
                  />
                </div>

                <button
                  :disabled="cvLoadingStatus"
                  type="button"
                  class="btn btn-primary mx-2"
                  @click="wrkSubAgentAdd()"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelchatbotPromptAdd"
      scrollable
      title="Add Chatbot Prompt"
      size="xxl"
    >
      <chatbotPromptAdd
        :propOpenedInModal="true"
        :propModules="modules"
        @emitClosechatbotPromptAddModal="closechatbotPromptAddModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closechatbotPromptAddModal()">Cancel</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelWrkServiceConfigAdd"
      scrollable
      title="Add Service Configuration"
      size="xxl"
    >
      <wrkServiceConfigAdd
        :propOpenedInModal="true"
        @emitCloseWrkServiceConfigAddModal="closeWrkServiceConfigAddModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkServiceConfigAddModal()">Cancel</b-button>
      </template>
    </b-modal>

    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { wrkSubAgents } from "../../../FackApi/api/wrkSubAgent.js"
import { wrkServiceConfigs } from "../../../FackApi/api/wrkServiceConfig.js"
import Multiselect from "vue-multiselect"
import { ChatbotPromptApiObj } from "../../../FackApi/api/chatbotPrompt.js"
import chatbotPromptAdd from "../ChatbotPrompt/ChatbotPromptAdd.vue"
import { moduleApiObj } from "../../../FackApi/api/module.js"
import wrkServiceConfigAdd from "./WrkServiceConfigAdd.vue"

export default {
  name: "wrkSubAgentAdd",
  props: {
    propOpenedInModal: { type: Boolean, default: false },
    propAgents: { type: Array, default: () => [] },
    propSelectedAgentId: { type: [String, Number], default: "" }
  },
  data () {
    return {
      cvCardTitle: "Add Sub Agent",
      cvSubmitBtn: "Add",
      cvSaIdLabel: "Sub Agent Id",
      cvSaOrderIdLabel: "Order Id",
      cvAgentIdLabel: "Agent",
      cvSaDescLabel: "Description",
      cvSaTypeLabel: "Sub Agent Type",
      cvSaActionLabel: "Action",
      cvSaPayloadLabel: "Payload (optional)",
      cvSaOutputLabel: "Output (optional)",
      cvSaSvcLabel: "Service Type",
      cvSaSvcLabelPlaceholder: "Service Type",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Sub Agent",
      cvLoadingStatus: false,
      vmWrkSubAgentFormData: Object.assign({}, this.initFormData()),
      // prompt
      cvPromptLoadingStatus: false,
      promptOptions: [],
      promptSelectedObj: null,
      promptCurrentBatchNo: 1,
      promptDataPerPage: 25,
      showModelchatbotPromptAdd: false,
      // wrk_service_config add modal (for API_CALL/DB_QUERY)
      showModelWrkServiceConfigAdd: false,
      // action list
      cvActionLoadingStatus: false,
      serviceActions: [],
      actionFilterObj: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      // visibility flags
      showActionDropdown: false,
      showFunctionToolInput: false,
      showPayload: false,
      showOutput: true,
      agentDisplayText: "",
      modules: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    isDbQueryType () {
      return String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase() === "DB_QUERY"
    },
    isPromptType () {
      return String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase() === "PROMPT"
    },
    showPayloadByType () {
      return this.showPayload
    }
  },
  async mounted () {
    socialvue.index()

    if (this.propSelectedAgentId) {
      this.vmWrkSubAgentFormData.agent_id = this.propSelectedAgentId
      this.agentDisplayText = String(this.propSelectedAgentId)

      if (Array.isArray(this.propAgents) && this.propAgents.length) {
        const match = this.propAgents.find(a => String(a.agent_id) === String(this.propSelectedAgentId))
        if (match) this.agentDisplayText = match.agent_name || match.agent_id
      }
    }

    this.onSaTypeChange()
  },
  components: { Multiselect, chatbotPromptAdd, wrkServiceConfigAdd },
  methods: {
    /**
     * moduleList
     */
    async moduleList () {
      try {
        const resp = await moduleApiObj.moduleList(this)
        if (resp && resp.resp_status) this.modules = resp.resp_data.data
      }
      catch (e) {
        console.error("moduleList error", e)
      }
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        sa_id: "",
        sa_order_id: "",
        agent_id: null,
        sa_desc: "",
        sa_payload: "",
        sa_output: "",
        sa_type: "PROMPT",
        sa_svc: null,
        sa_action: null
      }
    },
    /**
     * getFixedServiceTypeForActions
     */
    getFixedServiceTypeForActions () {
      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
      if (t === "API_CALL") return "api"
      if (t === "DB_QUERY") return "DB"
      return ""
    },
    /**
     * onSaTypeChange
     */
    onSaTypeChange () {
      // reset dependent values
      this.vmWrkSubAgentFormData.sa_action = null
      this.vmWrkSubAgentFormData.sa_payload = null
      this.vmWrkSubAgentFormData.sa_output = null
      this.vmWrkSubAgentFormData.sa_svc = null
      this.actionFilterObj = null
      this.serviceActions = []

      this.showActionDropdown = false
      this.showFunctionToolInput = false
      this.showPayload = false
      this.showOutput = true

      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()

      if (t === "PROMPT") {
        this.showActionDropdown = false
        this.showFunctionToolInput = false
        this.showPayload = false
        this.loadPromptOptions(true)
      }
      else if (t === "API_CALL") {
        this.vmWrkSubAgentFormData.sa_svc = "api"
        this.showActionDropdown = true
        this.showPayload = true
        this.showOutput = true
        this.loadServiceActionsForFixedServiceType("api")
      }
      else if (t === "DB_QUERY") {
        this.vmWrkSubAgentFormData.sa_svc = "DB"
        this.showActionDropdown = true
        this.showFunctionToolInput = false
        this.showPayload = true
        this.showOutput = true
        this.loadServiceActionsForFixedServiceType("DB")
      }
      else if (t === "FUNCTION") {
        this.showActionDropdown = false
        this.showFunctionToolInput = true
        this.showPayload = true
        this.showOutput = true
      }
      else if (t === "TOOL") {
        this.showActionDropdown = false
        this.showFunctionToolInput = true
        this.showPayload = true
        this.showOutput = true
      }
    },
    /**
     * loadServiceActionsForFixedServiceType
     */
    async loadServiceActionsForFixedServiceType (serviceType) {
      this.cvActionLoadingStatus = true
      try {
        this.serviceActions = []
        this.actionFilterObj = null
        this.vmWrkSubAgentFormData.sa_action = ""

        const resp = await wrkServiceConfigs.wrkServiceConfigList(this, {
          service_type: serviceType,
          search_param: "",
          currentBatchNo: 1,
          dataPerPage: this.dataPerPage
        })

        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.serviceActions = resp.resp_data.data
        }
      }
      catch (e) {
        console.error("loadServiceActionsForFixedServiceType error", e)
        this.serviceActions = []
      }
      finally {
        this.cvActionLoadingStatus = false
      }
    },
    /**
     * onActionSearchChange
     */
    async onActionSearchChange (search) {
      const fixedServiceType = this.getFixedServiceTypeForActions()
      if (!fixedServiceType) return

      const s = String(search || "").trim()
      if (s.length < 2) {
        this.currentBatchNo = 1
        this.actionFilterObj = null
        await this.loadServiceActionsForFixedServiceType(fixedServiceType)
        return
      }

      try {
        this.cvActionLoadingStatus = true
        const resp = await wrkServiceConfigs.wrkServiceConfigList(this, {
          service_type: fixedServiceType,
          search_param: s,
          currentBatchNo: 1,
          dataPerPage: this.dataPerPage
        })

        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.serviceActions = resp.resp_data.data
        }
        else {
          this.serviceActions = []
        }
      }
      catch (e) {
        console.error("onActionSearchChange error", e)
        this.serviceActions = []
      }
      finally {
        this.cvActionLoadingStatus = false
      }
    },
    /**
     * onActionSelected
     */
    onActionSelected (val) {
      this.actionFilterObj = val
      const action = val && val.service_activity
      this.vmWrkSubAgentFormData.sa_action = action || null

      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
      if (t === "API_CALL" || t === "DB_QUERY") {
        this.onAutoPopulatePayloadOutputForApiCall(val)
      }
    },
    /**
     * onAutoPopulatePayloadOutputForApiCall
     */
    onAutoPopulatePayloadOutputForApiCall (selectedAction) {
      const payloadFromConfig = selectedAction && selectedAction.service_activity_payload
      const outputFromConfig = selectedAction && selectedAction.service_activity_desc

      // payload
      if (payloadFromConfig === null || payloadFromConfig === undefined) this.vmWrkSubAgentFormData.sa_payload = ""
      else if (typeof payloadFromConfig === "string") this.vmWrkSubAgentFormData.sa_payload = payloadFromConfig
      else this.vmWrkSubAgentFormData.sa_payload = JSON.stringify(payloadFromConfig)

      // output / description
      if (outputFromConfig === null || outputFromConfig === undefined) this.vmWrkSubAgentFormData.sa_output = ""
      else if (typeof outputFromConfig === "string") this.vmWrkSubAgentFormData.sa_output = outputFromConfig
      else this.vmWrkSubAgentFormData.sa_output = JSON.stringify(outputFromConfig)
    },
    /**
     * openPromptAddModal
     */
    openPromptAddModal () {
      this.showModelchatbotPromptAdd = true
      this.moduleList()
    },

    /**
     * openWrkServiceConfigAddModal
     */
    openWrkServiceConfigAddModal () {
      this.showModelWrkServiceConfigAdd = true
    },
    /**
     * closechatbotPromptAddModal
     */
    closechatbotPromptAddModal () {
      this.showModelchatbotPromptAdd = false
      this.promptCurrentBatchNo = 1
      this.loadPromptOptions(true)
    },

    /**
     * closeWrkServiceConfigAddModal
     */
    closeWrkServiceConfigAddModal () {
      this.showModelWrkServiceConfigAdd = false

      // Refresh the action dropdown list after adding a service config
      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
      if (t === "API_CALL") {
        this.loadServiceActionsForFixedServiceType("api")
      }
      else if (t === "DB_QUERY") {
        this.loadServiceActionsForFixedServiceType("DB")
      }
    },
    /**
     * loadPromptOptions
     */
    async loadPromptOptions (initialLoad = false) {
      try {
        this.cvPromptLoadingStatus = true
        const whereFilter = {
          search_param: "",
          currentBatchNo: initialLoad ? 1 : this.promptCurrentBatchNo,
          dataPerPage: this.promptDataPerPage
        }
        const resp = await ChatbotPromptApiObj.chatbotPromptList(this, whereFilter)
        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.promptOptions = resp.resp_data.data
          if (String(this.vmWrkSubAgentFormData.sa_action || "").trim()) {
            const match = this.promptOptions.find(p => String(p.prompt) === String(this.vmWrkSubAgentFormData.sa_action))
            if (match) this.promptSelectedObj = match
          }
        }
        else {
          this.promptOptions = []
          this.promptSelectedObj = null
        }
      }
      catch (e) {
        console.error("loadPromptOptions error", e)
        this.promptOptions = []
        this.promptSelectedObj = null
      }
      finally {
        this.cvPromptLoadingStatus = false
      }
    },
    /**
     * onPromptSearchChange
     */
    async onPromptSearchChange (search) {
      const s = String(search || "").trim()
      if (!s) {
        this.promptCurrentBatchNo = 1
        await this.loadPromptOptions(true)
        return
      }

      try {
        this.cvPromptLoadingStatus = true
        const resp = await ChatbotPromptApiObj.chatbotPromptList(this, {
          search_param: s,
          currentBatchNo: 1,
          dataPerPage: this.promptDataPerPage
        })

        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.promptOptions = resp.resp_data.data
        }
        else {
          this.promptOptions = []
        }
      }
      catch (e) {
        console.error("onPromptSearchChange error", e)
        this.promptOptions = []
      }
      finally {
        this.cvPromptLoadingStatus = false
      }
    },
    /**
     * onPromptSelected
     */
    onPromptSelected (val) {
      this.promptSelectedObj = val
      this.vmWrkSubAgentFormData.sa_action = val && val.prompt ? val.prompt : ""
    },
    /**
     * validate
     */
    validate () {
      try {
        if (!String(this.vmWrkSubAgentFormData.sa_id || "").trim()) {
          this.toastMsg = "Missing Sub Agent Id"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(this.vmWrkSubAgentFormData.sa_order_id || "").trim()) {
          this.toastMsg = "Missing order"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(this.vmWrkSubAgentFormData.agent_id || "").trim()) {
          this.toastMsg = "Missing agent"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(this.vmWrkSubAgentFormData.sa_desc || "").trim()) {
          this.toastMsg = "Missing description"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
        if (!t) {
          this.toastMsg = "Missing type"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if ((t === "API_CALL" || t === "DB_QUERY" || t === "PROMPT" || t === "FUNCTION" || t === "TOOL") && !String(this.vmWrkSubAgentFormData.sa_action || "").trim()) {
          this.toastMsg = "Missing action"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        // best-effort JSON checks
        const payload = String(this.vmWrkSubAgentFormData.sa_payload || "").trim()
        if (payload && t !== "DB_QUERY") {
          try { JSON.parse(payload) }
          catch (e) {
            this.toastMsg = "Invalid payload JSON (use strict JSON). Example: {\"xyz\": \"abc\"}"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        const output = String(this.vmWrkSubAgentFormData.sa_output || "").trim()
        if (output && (t === "FUNCTION" || t === "TOOL")) {
          try { JSON.parse(output) }
          catch (e) {
            this.toastMsg = "Invalid output JSON (use strict JSON). Example: {\"gps_id\": \"123\"}"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        return true
      }
      catch (e) {
        console.error("validate error", e)
        return false
      }
    },
    /**
     * wrkSubAgentAdd
     */
    async wrkSubAgentAdd () {
      if (!this.validate()) return

      try {
        this.cvLoadingStatus = true
        const resp = await wrkSubAgents.wrkSubAgentAdd(this, this.vmWrkSubAgentFormData)
        if (resp && !resp.resp_status) {
          this.toastMsg = resp.resp_msg || "Failed to add sub agent"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.toastMsg = "Sub agent added successfully"
        this.toastVariant = "success"
        this.showToast = true

        if (this.propOpenedInModal) this.$emit("emitCloseWrkSubAgentAddModal")

        this.vmWrkSubAgentFormData = Object.assign({}, this.initFormData())
        this.vmWrkSubAgentFormData.agent_id = this.propSelectedAgentId || ""
        this.agentDisplayText = this.propSelectedAgentId ? String(this.propSelectedAgentId) : ""
        this.onSaTypeChange()
      }
      catch (e) {
        console.error("wrkSubAgentAdd error", e)
        this.toastMsg = "Failed to add sub agent"
        this.toastVariant = "danger"
        this.showToast = true
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
.reference-textarea-box {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
}
.reference-html {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}
.reference-html::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.reference-html::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.reference-html::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.reference-html::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
